export interface Comic {
  id: string;
  title: string;
  cover: string;
  tags: string[];
  score: number;
  author: string;
  status: string;
  chapter: string;
  description: string;
}

export const comics: Comic[] = [
  {
    id: "xinghai-huiying",
    title: "星海回响",
    cover: "https://readdy.ai/api/search-image?query=Young%20space%20adventurer%20with%20silver%20hair%20floating%20in%20a%20starry%20cosmic%20nebula%20beside%20a%20glowing%20starship%2C%20vibrant%20anime%20manga%20cover%20art%2C%20warm%20golden%20and%20coral%20lighting%2C%20dynamic%20composition%2C%20high%20detail%20digital%20painting%2C%20dramatic%20and%20epic%20mood&width=600&height=800&seq=cover-01&orientation=portrait",
    tags: ["科幻", "冒险"],
    score: 9.6,
    author: "北辰旅人",
    status: "连载中",
    chapter: "更新至第 128 话",
    description: "少女洛笙意外获得一枚上古星图，从此踏上穿越银河、寻找失落文明的冒险之旅。宏大的宇宙观与细腻的人物成长交织，被读者誉为近五年最值得追的国产太空科幻长篇。",
  },
  {
    id: "wuyi-shaonian",
    title: "雾隐少年",
    cover: "https://readdy.ai/api/search-image?query=Mysterious%20teenage%20boy%20in%20a%20misty%20ancient%20town%20at%20dusk%20holding%20a%20glowing%20lantern%2C%20dark%20moody%20mystery%20atmosphere%20with%20warm%20orange%20light%20accents%2C%20anime%20manga%20cover%20illustration%2C%20cinematic%20depth%2C%20high%20detail&width=600&height=800&seq=cover-02&orientation=portrait",
    tags: ["悬疑", "推理"],
    score: 9.4,
    author: "雾里看花",
    status: "连载中",
    chapter: "更新至第 96 话",
    description: "在一座终年被浓雾笼罩的古镇，少年阿默能看见寻常人看不见的灵雾。每一起离奇案件背后，都隐藏着这座小镇不愿被揭开的秘密。层层反转的烧脑推理令人欲罢不能。",
  },
  {
    id: "xindong-bianlidian",
    title: "心动便利店",
    cover: "https://readdy.ai/api/search-image?query=Cute%20cheerful%20girl%20and%20boy%20students%20in%20front%20of%20a%20warm%20convenience%20store%20at%20cherry%20blossom%20evening%2C%20soft%20romantic%20pink%20and%20orange%20palette%2C%20anime%20slice%20of%20life%20cover%20art%2C%20bright%20happy%20mood%2C%20high%20detail&width=600&height=800&seq=cover-03&orientation=portrait",
    tags: ["校园", "恋爱"],
    score: 9.2,
    author: "桃子汽水",
    status: "已完结",
    chapter: "全 82 话",
    description: "深夜便利店打烊前的半小时，是林小满和顾言心照不宣的秘密时光。青涩又温暖的双向暗恋，配上烟火气十足的校园日常，甜度刚好，是恋爱题材的治愈之作。",
  },
  {
    id: "changan-shiguanglu",
    title: "长安食光录",
    cover: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20chef%20serving%20steaming%20delicious%20food%20at%20a%20candlelit%20Tang%20dynasty%20street%20stall%2C%20warm%20golden%20and%20vermilion%20tones%2C%20painterly%20anime%20manga%20cover%20art%2C%20rich%20appetizing%20detail%2C%20elegant%20atmosphere&width=600&height=800&seq=cover-04&orientation=portrait",
    tags: ["古风", "美食"],
    score: 9.5,
    author: "一勺长安",
    status: "连载中",
    chapter: "更新至第 74 话",
    description: "一介小厨娘误入大唐盛世，凭借一手现代厨艺，从长安城的小吃摊一路做到御膳房。色香味俱全的美食画面，加上考究的唐代风物，让人看得口水直流。",
  },
  {
    id: "shenyuan-qishi",
    title: "深渊骑士",
    cover: "https://readdy.ai/api/search-image?query=Brave%20knight%20in%20ornate%20armor%20standing%20before%20a%20glowing%20crystal%20abyss%2C%20epic%20fantasy%20adventure%2C%20deep%20teal%20and%20warm%20gold%20palette%2C%20dramatic%20anime%20manga%20cover%20art%2C%20heroic%20composition%2C%20high%20detail&width=600&height=800&seq=cover-05&orientation=portrait",
    tags: ["奇幻", "冒险"],
    score: 9.3,
    author: "重甲蜗牛",
    status: "连载中",
    chapter: "更新至第 143 话",
    description: "世界崩裂，深渊之门洞开。被冠以背叛者之名的骑士亚瑟，背负宿命重回战场，在黑暗中守护仅存的光明。格局宏大的史诗级奇幻冒险，战斗分镜堪称教科书级别。",
  },
  {
    id: "zhiyu-shitang",
    title: "治愈食堂",
    cover: "https://readdy.ai/api/search-image?query=Cozy%20warm%20small%20kitchen%20restaurant%20with%20steaming%20dishes%20and%20a%20gentle%20chef%20cat%2C%20soft%20warm%20cream%20and%20coral%20tones%2C%20healing%20slice%20of%20life%20anime%20cover%20art%2C%20calm%20soothing%20mood%2C%20high%20detail&width=600&height=800&seq=cover-06&orientation=portrait",
    tags: ["治愈", "日常"],
    score: 9.1,
    author: "暖胃喵",
    status: "连载中",
    chapter: "更新至第 118 话",
    description: "街角一间只营业到深夜的小食堂，接待每一位带着故事的疲惫旅人。一碗热汤、一份甜点，治愈的不只是胃，更是心。温柔得让人想落泪的治愈日常之作。",
  },
  {
    id: "jixian-jingsu",
    title: "极限竞速",
    cover: "https://readdy.ai/api/search-image?query=Young%20racer%20driving%20a%20red%20sports%20car%20at%20high%20speed%20through%20neon%20lit%20city%20at%20night%2C%20dynamic%20motion%20lines%2C%20fiery%20orange%20and%20warm%20gold%20palette%2C%20energetic%20anime%20manga%20cover%20art%2C%20high%20detail&width=600&height=800&seq=cover-07&orientation=portrait",
    tags: ["热血", "运动"],
    score: 9.0,
    author: "油门到底",
    status: "连载中",
    chapter: "更新至第 67 话",
    description: "天才车手韩野从街头飙车少年一路冲向顶级方程式赛场。极速狂飙的紧张感、热血的团队羁绊，每一场比赛都让人肾上腺素飙升，是年度最燃的运动漫画之一。",
  },
  {
    id: "xiuxian-bianlidian",
    title: "修仙便利店",
    cover: "https://readdy.ai/api/search-image?query=Comedic%20cultivator%20in%20robes%20running%20a%20roadside%20convenience%20store%20with%20floating%20magic%20items%2C%20playful%20warm%20orange%20and%20teal%20palette%2C%20funny%20expressive%20anime%20manga%20cover%20art%2C%20lively%20composition%2C%20high%20detail&width=600&height=800&seq=cover-08&orientation=portrait",
    tags: ["搞笑", "玄幻"],
    score: 8.9,
    author: "熬夜修仙",
    status: "连载中",
    chapter: "更新至第 155 话",
    description: "渡劫失败的散仙，在人间小镇开了一家24小时修仙便利店。灵丹妙药、飞剑外卖、渡劫套餐一应俱全，笑点密集又不失温情，是当下最火的下饭搞笑漫。",
  },
  {
    id: "yinhe-zhentanshe",
    title: "银河侦探社",
    cover: "https://readdy.ai/api/search-image?query=Stylish%20young%20detective%20team%20in%20a%20futuristic%20space%20station%20solving%20mysteries%20with%20holograms%2C%20warm%20gold%20and%20coral%20accents%20against%20deep%20space%2C%20sleek%20anime%20manga%20cover%20art%2C%20intriguing%20mood%2C%20high%20detail&width=600&height=800&seq=cover-09&orientation=portrait",
    tags: ["科幻", "推理"],
    score: 9.2,
    author: "星轨侦探",
    status: "连载中",
    chapter: "更新至第 88 话",
    description: "在宇宙边缘的移民都市，一支看似不靠谱的侦探小队，屡屡侦破轰动全银河的离奇案件。硬核科幻设定加烧脑推理，冷门题材却被画出了极强可看性。",
  },
  {
    id: "miaosheng-guocha",
    title: "喵生观察日志",
    cover: "https://readdy.ai/api/search-image?query=Adorable%20fluffy%20cats%20doing%20human%20like%20daily%20activities%20in%20a%20bright%20cozy%20home%2C%20warm%20pastel%20cream%20and%20coral%20tones%2C%20cute%20comedic%20anime%20manga%20cover%20art%2C%20joyful%20and%20soft%2C%20high%20detail&width=600&height=800&seq=cover-10&orientation=portrait",
    tags: ["萌宠", "搞笑"],
    score: 9.0,
    author: "铲屎官日记",
    status: "连载中",
    chapter: "更新至第 202 话",
    description: "三只性格迥异的猫咪，在人类家里上演一幕幕爆笑又暖心的生活日常。软萌画风配上天马行空的脑洞，云吸猫爱好者的快乐源泉，看一话心情好一整天。",
  },
];

export interface Category {
  name: string;
  count: number;
  icon: string;
  desc: string;
}

export const categories: Category[] = [
  { name: "热血", count: 326, icon: "ri-fire-fill", desc: "战斗燃向，看得热血沸腾" },
  { name: "奇幻", count: 412, icon: "ri-sword-fill", desc: "异世界与魔法冒险" },
  { name: "校园", count: 288, icon: "ri-school-fill", desc: "青涩校园青春日常" },
  { name: "悬疑", count: 197, icon: "ri-mist-fill", desc: "烧脑推理与层层反转" },
  { name: "治愈", count: 243, icon: "ri-cup-fill", desc: "温暖治愈，抚慰心灵" },
  { name: "科幻", count: 185, icon: "ri-rocket-2-fill", desc: "宇宙星空与未来科技" },
  { name: "恋爱", count: 356, icon: "ri-heart-3-fill", desc: "心动日常与甜蜜羁绊" },
  { name: "搞笑", count: 301, icon: "ri-emotion-laugh-fill", desc: "爆笑神作，解压必备" },
];

export interface RankingItem {
  comicId: string;
  score: number;
  trend: "up" | "down" | "flat";
}

export const weeklyRanking: RankingItem[] = [
  { comicId: "xinghai-huiying", score: 9.6, trend: "up" },
  { comicId: "xiuxian-bianlidian", score: 9.4, trend: "up" },
  { comicId: "wuyi-shaonian", score: 9.3, trend: "up" },
  { comicId: "shenyuan-qishi", score: 9.2, trend: "flat" },
  { comicId: "changan-shiguanglu", score: 9.1, trend: "up" },
  { comicId: "miaosheng-guocha", score: 9.0, trend: "down" },
  { comicId: "xindong-bianlidian", score: 8.9, trend: "down" },
  { comicId: "yinhe-zhentanshe", score: 8.8, trend: "up" },
  { comicId: "zhiyu-shitang", score: 8.7, trend: "down" },
  { comicId: "jixian-jingsu", score: 8.6, trend: "up" },
];

export const monthlyRanking: RankingItem[] = [
  { comicId: "shenyuan-qishi", score: 9.6, trend: "up" },
  { comicId: "xinghai-huiying", score: 9.5, trend: "flat" },
  { comicId: "changan-shiguanglu", score: 9.4, trend: "up" },
  { comicId: "wuyi-shaonian", score: 9.3, trend: "up" },
  { comicId: "zhiyu-shitang", score: 9.2, trend: "down" },
  { comicId: "yinhe-zhentanshe", score: 9.1, trend: "up" },
  { comicId: "xiuxian-bianlidian", score: 9.0, trend: "down" },
  { comicId: "miaosheng-guocha", score: 8.9, trend: "flat" },
  { comicId: "xindong-bianlidian", score: 8.8, trend: "down" },
  { comicId: "jixian-jingsu", score: 8.7, trend: "up" },
];

export const allTimeRanking: RankingItem[] = [
  { comicId: "changan-shiguanglu", score: 9.6, trend: "up" },
  { comicId: "xinghai-huiying", score: 9.5, trend: "flat" },
  { comicId: "shenyuan-qishi", score: 9.4, trend: "flat" },
  { comicId: "wuyi-shaonian", score: 9.3, trend: "up" },
  { comicId: "xindong-bianlidian", score: 9.2, trend: "down" },
  { comicId: "zhiyu-shitang", score: 9.1, trend: "down" },
  { comicId: "miaosheng-guocha", score: 9.0, trend: "flat" },
  { comicId: "yinhe-zhentanshe", score: 8.9, trend: "up" },
  { comicId: "xiuxian-bianlidian", score: 8.8, trend: "up" },
  { comicId: "jixian-jingsu", score: 8.7, trend: "down" },
];

export interface ReleaseItem {
  comicId: string;
  chapter: string;
  updateAt: string;
}

export const releases: ReleaseItem[] = [
  { comicId: "miaosheng-guocha", chapter: "第 202 话", updateAt: "今天 09:20" },
  { comicId: "xinghai-huiying", chapter: "第 128 话", updateAt: "今天 08:45" },
  { comicId: "xiuxian-bianlidian", chapter: "第 155 话", updateAt: "昨天 22:10" },
  { comicId: "zhiyu-shitang", chapter: "第 118 话", updateAt: "昨天 20:30" },
  { comicId: "shenyuan-qishi", chapter: "第 143 话", updateAt: "昨天 18:05" },
  { comicId: "wuyi-shaonian", chapter: "第 96 话", updateAt: "3 天前" },
];